import { render, staticRenderFns } from "./TradeInProgram.vue?vue&type=template&id=5db53a22&scoped=true"
import script from "./TradeInProgram.vue?vue&type=script&lang=js"
export * from "./TradeInProgram.vue?vue&type=script&lang=js"
import style0 from "./TradeInProgram.vue?vue&type=style&index=0&id=5db53a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db53a22",
  null
  
)

export default component.exports